import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  const overlayRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === overlayRef.current) {
      onClose();
    }
  };
  if (!isOpen) return null;
  return createPortal(<div ref={overlayRef} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200" onClick={handleOverlayClick} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-201">
      <div ref={contentRef} className="relative w-full max-w-2xl max-h-[85vh] overflow-y-auto bg-slate-900 border border-slate-800 rounded-xl shadow-2xl shadow-black/50 animate-in zoom-in-95 duration-200" data-id="element-202">
        <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-4 bg-slate-900/95 backdrop-blur border-b border-slate-800" data-id="element-203">
          <h2 id="modal-title" className="text-xl font-serif font-bold text-amber-50" data-id="element-204">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-amber-400 transition-colors rounded-lg hover:bg-slate-800" aria-label="Cerrar" data-id="element-205">
            <X className="w-5 h-5" data-id="element-206" />
          </button>
        </div>

        <div className="p-6 md:p-8 text-slate-300 space-y-4" data-id="element-207">{children}</div>
      </div>
    </div>, document.body);
}